import EditableCardEntryUserBase from "./EditableCardEntryUserBase";

const EditableCardEntryUser = ({fancy = false, isEditing, onEdit, baseValue, displayLabel = "User", filterFunction = () => true, showPCID = false}) => {
    return (
        <EditableCardEntryUserBase
            isEditing={isEditing}
            onEdit={onEdit}
            baseValue={baseValue}
            displayLabel={displayLabel}
            filterFunction={filterFunction}
            isMultiSelect={false}
            showPCID={showPCID}
            fancy={fancy}
        />
    );
}

export default EditableCardEntryUser;